import { MENU_HEIGHT } from '@library/uikit/src/widgets/Menu/config'
import Container from 'components/Layout/Container'
import { useTranslation } from '@library/localization'
import { useRouter } from 'next/router'
import BaseSubMenu from '../components/BaseSubMenu'
import { yourBaseUrl } from '../constants'

const Header: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const itemsConfig = [
    {
      label: t('In Wallet'),
      href: `${yourBaseUrl}`,
    },
    {
      label: t('On Sale'),
      href: `${yourBaseUrl}#sale`,
    },
    {
      label: t('Offering'),
      href: `${yourBaseUrl}#offering`,
    },
  ]

  return (
    <>
      <Container>
        <BaseSubMenu
          justifyContent="start"
          items={itemsConfig}
          activeItem={router.asPath}
          mt={MENU_HEIGHT + 72}
          hoverColor="white"
          activeColor="white"
          mb="8px"
        />
      </Container>
    </>
  )
}

export default Header
